import { useEffect } from "react";
import { updateCurrentUser, updateMiqCollection } from "wasp/client/operations";
import { useAuth } from "wasp/client/auth";
import { shopifyBackendBaseUrl } from "../admin/dashboards/urls";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";

export default function AuthSucceededPage() {
  const { currentCollection } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (currentCollection?.collection?.miqShopifyDomain) {
      const shopName = currentCollection?.collection?.miqShopifyDomain.split(".myshopify.com")[0];
      window.location.href = getPricingUrl(shopName);
    } else {
      const params = new URLSearchParams(window.location.search);
      const shop = params.get("shop");
      if(shop){
        if(!currentCollection?.collection?.id){
          alert("Collection not found");
          return;
        }
        updateMiqCollection({id: currentCollection?.collection?.id, miqShopifyDomain: shop }).then(() => {
          window.location.href = getPricingUrl(shop);
        })
      } else{
        const form = document.getElementById(
          "install-app-form"
        ) as HTMLFormElement;
        if (form) {
          form.submit();
        }
      }
    }
  }, [currentCollection?.collection]);

  const getPricingUrl = (shopName: string) => {
    return `https://admin.shopify.com/store/${shopName.split(".myshopify.com")[0]}/charges/marketplaceiq/pricing_plans`
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h1 className="text-xl font-semibold">
          {window.location.search.includes("shop")
            ? "Redirecting..."
            : "Redirecting..."}
        </h1>
        <p className="mt-2 text-gray-600">Please wait...</p>
        <form
          id="install-app-form"
          action={`${shopifyBackendBaseUrl}/authorize`}
          method="GET"
        >
          <input
            type="hidden"
            name="redirectPath"
            value={`${window.location.origin}/auth/redirect`}
          />
          <input
            type="hidden"
            name="shop"
            value={currentCollection?.collection?.miqShopifyDomain ?? ""}
          />
        </form>
      </div>
    </div>
  );
}
